if (!customElements.get('quad-kit-picker')) {
  customElements.define('quad-kit-picker', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-quad-choice]');
        if (!select) return;
        const src = select.selectedOptions[0]?.dataset.image;
        const image = select.closest('.quad-kit__part').querySelector('img');
        if (src && image) { image.src = src; image.removeAttribute('srcset'); }
      }, { signal: this.abort.signal });
      document.documentElement.addEventListener('cart:change', event => {
        const items = event.detail?.cart?.items;
        if (!Array.isArray(items)) return;
        const axle = items.some(item => [43990557294859,46541721043211].includes(Number(item.variant_id || item.id)));
        const wheels = items.some(item => [43990557360395,52726838001931].includes(Number(item.variant_id || item.id)));
        const status = this.querySelector('[data-quad-status]');
        if (status) status.textContent = this.dataset[axle && wheels ? 'both' : axle ? 'wheels' : wheels ? 'axle' : 'empty'];
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!customElements.get('quad-kit-cart-note')) {
  customElements.define('quad-kit-cart-note', class extends HTMLElement {
    connectedCallback() {
      this.onclick = event => {
        if (event.target.closest('a')) this.closest('cart-drawer')?.querySelector('button[is="close-button"]')?.click();
      };
    }
  });
}
